import { compose, map, prop } from 'ramda';

import { compact, path, pathOr } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { deprecatedPageEntity } from './internal';

const getUIDList = compose(
  compact,
  map(path('pushhot.uid')),
  pathOr([], 'body.0.items')
);

const processNewsroom = (data) =>
  compact({
    uid: DocumentType.NEWSROOM,
    type: DocumentType.NEWSROOM,
    articles: getUIDList(data),
    canonicalParameters: ['page'],
  });

export const Newsroom = deprecatedPageEntity(DocumentType.NEWSROOM, {
  processStrategy: (entity) => ({
    ...processNewsroom(prop('data', entity)),
  }),
});
